// extracted by mini-css-extract-plugin
module.exports = {"acceptInviteContainer":"acceptInvite_acceptInviteContainer__2FJFI","heading":"acceptInvite_heading__18sbR"};